import RightIcon from "../assets/icons/right-icon.svg";
// import { getBasePrice } from "../blockchain/lotteryClient";


const borderClasses: Record<string, string> = {
    "Регулярная игра": "regular-border",
    "Стандартная игра": "standard-border",
    "Премиум игра": "premium-border",
};



function GameCategoryCard(props: any) {
   

    return (
        <div
            className={`games-category-card ${borderClasses[props.name] || ""}`}
            onClick={props.func}
        >
            <div className="games-category-card_info">
                <img src={props.gameIcon} alt="icon" />
                <div className="games-category-card_info__content">
                    <div className="games-category-card_info__content___name">
                        {props.name}
                    </div>
                    <div className="games-category-card_info__content___price">
                        {props.subTitle}: {props.ticketPrice} GRAM
                    </div>
                </div>
            </div>
            <div
                className={`games-category-card_button ${borderClasses[props.name] || ""}`}
            >
                <img src={RightIcon} alt="right" width='32' height='32' />
            </div>
        </div>
    )
}

export default GameCategoryCard